import { Button, Form, Input, Modal } from "antd";

const CreateEditCourseContestModal = ({
  isModalOpen = false,
  isEdit = false,
  initialValues = {},
  setIsModalOpen = () => {},
  handleCreateEditCourseContest = () => {}
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (values) => {
    handleCreateEditCourseContest(values);
  };

  let formInitialValues = initialValues || {};

  return (
    <Modal
      title="Create New Course Contest"
      open={isModalOpen}
      footer={[]}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        initialValues={isEdit ? formInitialValues : {}}
        name="new_course_contest_form"
        onFinish={handleFormSubmit}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter the contest name!"
            }
          ]}
        >
          <Input placeholder="Some Cool Name!" />
        </Form.Item>

        <Form.Item
          name="contestLink"
          label="Contest Link"
          rules={[
            {
              required: true,
              message: "Please enter the codeforces link!"
            }
          ]}
        >
          <Input placeholder="Link of the contest" />
        </Form.Item>

        <Form.Item name="preRequisitesText" label="Pre-requisite Text">
          <Input placeholder="Pre-requisite Text" />
        </Form.Item>

        <Form.Item name="editorialLink" label="Editorial Link">
          <Input placeholder="Link of the Editorial" />
        </Form.Item>

        <Form.Item
          name="sequenceNumber"
          label="Sequence Number"
          rules={[
            {
              required: true,
              message: "Please enter a sequence number!"
            }
          ]}
        >
          <Input placeholder="Sequence Number on the UI" />
        </Form.Item>

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            {isEdit ? "Update" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default CreateEditCourseContestModal;
